export default "__VITE_ASSET__DyJkF0h3__"